import PropTypes from "prop-types";
import { useSwiperSlide } from "swiper/react";
import { Box } from "@mui/material";

import { useScreen } from "hooks";

import { ContentWrapper, Logo, Title, Description, InactiveOverlay } from "./styles";

const truncateText = (text, maxLength) => {
  if (!text) return text;
  return text.length > maxLength ? `${text.substring(0, maxLength)}…` : text;
};

const Content = ({ logo, title, description }) => {
  const { isMobile } = useScreen();
  const truncatedDescription = truncateText(description, 222);
  const swiperSlide = useSwiperSlide();

  return (
    <>
      {logo && <Logo src={logo} alt="Logo" width={256} widthMobile={141} />}
      <ContentWrapper display="flex" flexDirection="column" justifyContent="flex-end" alignItems="center">
        <Box mb={isMobile ? 3.75 : 5} width="95%">
          {title && (
            <Title color="white" textAlign="center" noWrap>
              {title}
            </Title>
          )}
          {truncatedDescription && (
            <Description color="white" textAlign="center">
              {truncatedDescription}
            </Description>
          )}
        </Box>
        {!swiperSlide?.isActive && <InactiveOverlay />}
      </ContentWrapper>
    </>
  );
};

Content.propTypes = {
  logo: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default Content;
